import { render, staticRenderFns } from "./syntheticlist.vue?vue&type=template&id=f7204c92&"
import script from "./syntheticlist.vue?vue&type=script&lang=js&"
export * from "./syntheticlist.vue?vue&type=script&lang=js&"
import style0 from "./syntheticlist.vue?vue&type=style&index=0&id=f7204c92&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports